// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1QNgJ","errorLogs":"EditorFooter_errorLogs__2vFPi"};